import { mapToTrackableProduct } from 'src/app/@utils/gtm-tracking/utils/mapToTrackableProduct';

import { ProductSearchViewModel } from '@models/api-search.models';

import { ProductList } from '../model';

export type ProductImpressionEvent = {
    event: 'view_item_list';
    ecommerce: {
        items: ProductList;
    };
};

export type ImpressionSource =
    | 'Search Results'
    | 'Related Products'
    | 'Product Gallery'
    | 'Last Seen'
    | 'Most Popular'
    | 'Most Popular By Category'
    | 'Most Popular By Brand'
    | 'By Product Id'
    | 'Campaign'
    | 'Other Also Bought Products'
    | 'Other Also Seen Products'
    | 'Other'
    | 'Retail Media Sponsored Products';

const listify = (
    products: (ProductSearchViewModel & { index?: number })[],
    impressionSource?: ImpressionSource
): ProductList =>
    products.map((product, index) => ({
        ...mapToTrackableProduct(product),
        index: product.index ?? index + 1,
        ...(impressionSource ? { item_list_name: impressionSource } : {})
    }));

export const trackProductImpressionEvent = (
    products: ProductSearchViewModel[],
    impressionSource?: ImpressionSource
): ProductImpressionEvent => ({
    event: 'view_item_list',
    ecommerce: {
        items: listify(products, impressionSource)
    }
});
